import { createFileRoute, notFound } from "@tanstack/react-router"

import { PassDetailRouteComponent } from "@/routes/_authenticated/account/passes/$passID"
import { parkPassesQueryOptions } from "@/utilities/hooks/queries/park"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/passes/$passID"
)({
  loader: async ({ context, params }) => {
    const rsp = await context.queryClient.ensureQueryData(
      parkPassesQueryOptions()
    )

    const pass = rsp.passes.find((p) => p.passID === params.passID)

    if (!pass) {
      throw notFound()
    }

    return {
      crumb: { label: pass.passName },
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { qrLookupID, passID } = Route.useParams()
  return <PassDetailRouteComponent passID={passID} qrLookupID={qrLookupID} />
}
